import { Tq4AntifoulingM } from "./tq4-antifouling.models";

export const TYPE_OF_ANTIFOULING_OPTIONS = [
  {
    value: "Organotin-free self polishing type",
    label: "Organotin-free self polishing type",
  },
  {
    value: "Organotin-free ablative type",
    label: "Organotin-free ablative type",
  },
  {
    value: "Organotin-free conventional type",
    label: "Organotin-free conventional type",
  },
  {
    value: "Biocide-free silicon type paint",
    label: "Biocide-free silicon type paint",
  },
];

export const INITIAL_FORM_DATA: Tq4AntifoulingM = {
  underWateHullCleaningDateOne: null,
  underWaterHullCleaningPortNameOne: "",
  underWateHullCleaningAreasCleanedOne: "",
  underWaterHullCleaningHullInspectedOne: "",
  underWaterHullCleaningHullCleanedOne: "",
  underWateHullCleaningPropellerPolishedOne: "",
  underWaterHullCleaningNzMpiStandardCleaningOne: "",
  underWateHullCleaningDateTwo: null,
  underWaterHullCleaningPortNameTwo: "",
  underWateHullCleaningAreasCleanedTwo: "",
  underWaterHullCleaningHullInspectedTwo: "",
  underWaterHullCleaningHullCleanedTwo: "",
  underWateHullCleaningPropellerPolishedTwo: "",
  underWaterHullCleaningNzMpiStandardCleaningTwo: "",
  dateOfIssuanceAntifoulingCertificate: null,
  dateOfPaintApplication: null,
  typeOfAntiFoulingSystem: { value: "", label: "" },
  antiFoulingSystemManufacturer: { value: "", label: "" },
  nameOfAntiFoulingsystemOne: { value: "", label: "" },
  nameOfAntiFoulingsystemOneOthers: "",
  nameOfAntiFoulingsystemTwo: { value: "", label: "" },
  nameOfAntiFoulingsystemTwoOthers: "",
  nameOfAntiFoulingsystemThree: { value: "", label: "" },
  nameOfAntiFoulingsystemThreeOthers: "",
  lastDryDockingDate: null,
  hasUnderwaterHullInspectionAfterLastDrydock: "",
  lastDryDockingLocation: "",
  antiFoulingBootTopCoating: "",
  antiFoulingVerticalBottomCoating: "",
  antiFoulingFlatBottomCoating: "",
  propellerPaintedCoated: "",
  serviceLifeAfsMonths: "",
  frequencyOfScheduledInspections: "",
  nextScheduledDryDocking: null,
  isThereAProcedurePlacedByOwners: "",
};
